import React, { useState, useEffect } from 'react';

const OrderHistory = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch order history from API
    const fetchOrderHistory = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch('/api/orders', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          setOrders(data.orders);
        } else {
          console.error('Failed to fetch orders');
        }
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderHistory();
  }, []);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="container mt-4">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Order History</h2>
      
      {orders.length === 0 ? (
        <div className="alert alert-info">
          You haven't placed any orders yet.
        </div>
      ) : (
        <div className="row">
          {orders.map(order => (
            <div key={order.id} className="col-md-6 mb-4">
              <div className="card">
                <div className="card-header d-flex justify-content-between">
                  <span>Order #{order.id}</span>
                  <span className={`badge ${getStatusBadgeClass(order.status)}`}>
                    {order.status}
                  </span>
                </div>
                <div className="card-body">
                  <p><strong>Date:</strong> {formatDate(order.created_at)}</p>
                  <p><strong>Total:</strong> ${order.total_amount}</p>
                  
                  <h6>Items:</h6>
                  <ul className="list-group list-group-flush">
                    {order.items.map(item => (
                      <li key={item.id} className="list-group-item d-flex justify-content-between">
                        <span>{item.name} x {item.quantity}</span>
                        <span>${item.price * item.quantity}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Helper function for status badge styling
const getStatusBadgeClass = (status) => {
  switch (status.toLowerCase()) {
    case 'completed':
      return 'bg-success';
    case 'preparing':
      return 'bg-warning';
    case 'pending':
      return 'bg-info';
    case 'cancelled':
      return 'bg-danger';
    default:
      return 'bg-secondary';
  }
};

export default OrderHistory;